module.exports = __webpack_public_path__ + "3c4a3b8fe36adbf799e6a872da1174ea.png";